/* Bedragkeuze op de cadeaukaart-productpagina. Hoort bij sections/cadeaukaart-product.liquid. */
(function () {
  var form = document.querySelector('[data-vck-form]');
  if (!form) return;
  form.addEventListener('change', function (e) {
    var r = e.target; if (!r || r.name !== 'id') return;
    var v = document.querySelector('[data-vck-visual-bedrag]'); if (v) v.textContent = r.dataset.prijsKort;
    var box = document.querySelector('[data-vck-bonus]'); if (!box) return;
    box.hidden = !r.dataset.bonus;
    box.querySelector('[data-vck-prijs]').textContent = r.dataset.prijs;
    var p2 = box.querySelector('[data-vck-prijs2]'); if (p2) p2.textContent = r.dataset.prijs;
    var p3 = box.querySelector('[data-vck-prijs3]'); if (p3) p3.textContent = r.dataset.prijs;
    var b2 = box.querySelector('[data-vck-bonus2]'); if (b2) b2.textContent = r.dataset.bonus;
    box.querySelector('[data-vck-bonusbedrag]').textContent = r.dataset.bonus;
  });
})();
